<template>
  <div class="not-found">
    <h1>{{ $t('Subscribe') }}</h1>
    <p>{{ $t('Please wait, we are performing some required actions to let you in...') }}</p>

    <router-link to="/" class="cmn--btn">
      <span>{{ $t('Go Back Home') }}</span>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useAuthStore } from '@/store/auth'

export default {
  name: "SubscribeView",
  methods: {
    ...mapActions(useAuthStore, ["subscribe"]),
  },

  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const phone = urlParams.get("msisdn");

    if (phone) {
      await this.subscribe(phone);
      // localStorage.setItem('redirectUrl', this.$route.fullPath);
      // get last redirect url from local storage and redirect to it if any
      const redirectUrl = localStorage.getItem('redirectUrl');
      if (redirectUrl) {
        this.$router.push(redirectUrl);
      } else {
        this.$router.push('/');
      }
    } else {
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 10vh;
  height: 50vh;
}
.not-found h1 {
  font-size: 6rem;
  color: #ff4040;
}
.not-found p {
  font-size: 1.5rem;
  margin: 1rem 0;
}
</style>
